import { ConstructionDiaryType } from '../graphql-types';
import { BackendDate } from '../helper/backend-frontend-conversion.helper';
import { MapMarkerFileDictionary } from './event.entity';

export enum ConstructionDiaryStatusEnum {
    Newly = 'NEWLY',
    Done = 'DONE',
}
export const ConstructionDiaryStatusEnumNameMap: Map<ConstructionDiaryStatusEnum, string> = new Map<ConstructionDiaryStatusEnum, string>([
    [ConstructionDiaryStatusEnum.Newly, 'Offen'],
    [ConstructionDiaryStatusEnum.Done, 'Erledigt'],
]);
export interface ConstructionDiaryEntityAdditionalData {
    weather: {
        description?: string;
        temp?: number;
    };
    leistungsergebnisseTemplateIds?: number[];
    mapMarker?: MapMarkerFileDictionary;
    /**
     * luksch
     */
    toolFee?: boolean;
    /**
     * luksch
     */
    smallAndSealingMaterial?: boolean;
    /**
     * luksch
     */
    workCompleted?: boolean;
}
export class ConstructionDiaryEntity {
    constructor(
        public Id: number = null,
        public BehinderungenErwachsene: string = null,
        public CommissionId: number = null,
        public CreatedAt: Date = null,
        public Date: Date = null,
        public DeletedAt: Date = null,
        public EventIds: number[] = null,
        public FileId: number = null,
        public GeneratedFileId: number = null,
        public Leistungsaenderungen: string = null,
        public Leistungsergebnisse: string = null,
        public PartnerId: number = null,
        public Status: ConstructionDiaryStatusEnum = null,
        public UpdatedAt: Date = null,
        public UserId: number = null,
        public AdditionalData: ConstructionDiaryEntityAdditionalData = null,
        public BesondereVorkommnisse: string = null,
        public TravelZoneId: number = null,
        public MaterialDeviceAsString: string = null,
        public Title: string = null,
        public ExecutingCompany: string = null,
        public Bedenken: string = null,
        public AppFileCount: number = null,
        public AppUploadedFileCount: number = null,
        public SignatureFileId: number = null,
        public ConstructionDiaryNumber: string = null,
        public Name: string = null,
    ) {}
    public static readonly GqlFields: Array<keyof ConstructionDiaryType> = [
        'additionalData',
        'besondereVorkommnisse',
        'behinderungenErschwernisse',
        'commissionId',
        'createdAt',
        'date',
        'deletedAt',
        'eventIds',
        'fileId',
        'generatedFileId',
        'id',
        'leistungsaenderungen',
        'leistungsergebnisse',
        'partnerId',
        'status',
        'updatedAt',
        'userId',
        'travelZoneId',
        'materialDeviceAsString',
        'executingCompany',
        'title',
        'bedenken',
        'appFileCount',
        'appUploadedFileCount',
        'signatureFileId',
        'constructionDiaryNumber',
        'name'
    ];
    public Clone(override: Partial<ConstructionDiaryEntity> = {}): ConstructionDiaryEntity {
        const attr = { ...this, ...override };
        return Object.assign(new ConstructionDiaryEntity(), attr);
    }
    public getStatusColor(): string {
        // die Farben stehen auch in styles.scss in klassen für den mat-datepicker
        return this.GeneratedFileId ? 'rgb(84, 84, 199)' : this.Status === ConstructionDiaryStatusEnum.Newly ? 'orange' : this.Status === ConstructionDiaryStatusEnum.Done ? 'green' : 'red'; // kommt eigentlich nie vor da this.Status nicht null sein sollte
    }
    public getStatusDescription(): string {
        return this.GeneratedFileId ? 'exportiert' : ConstructionDiaryStatusEnumNameMap.get(this.Status);
    }
    public getMaterialDevices() {
        if (this.MaterialDeviceAsString) {
            try {
                const res: { name: string; quantity: number; quantityTypeId: number }[] = JSON.parse(this.MaterialDeviceAsString);
                return res;
            } catch (error) {
                throw 'materialDeviceAsString from constructionDiary with Id:' + this.Id + 'not valid';
            }
        } else {
            return [];
        }
    }
}

export function ConstructionDiaryEntityFromBackend(res: ConstructionDiaryType): ConstructionDiaryEntity {
    return new ConstructionDiaryEntity(
        res.id,
        res.behinderungenErschwernisse,
        res.commissionId,
        res.createdAt && BackendDate(res.createdAt),
        res.date && BackendDate(res.date),
        res.deletedAt && BackendDate(res.deletedAt),
        res.eventIds,
        res.fileId,
        res.generatedFileId,
        res.leistungsaenderungen,
        res.leistungsergebnisse,
        res.partnerId,
        res.status,
        res.updatedAt && BackendDate(res.updatedAt),
        res.userId,
        res.additionalData as any,
        res.besondereVorkommnisse,
        res.travelZoneId,
        res.materialDeviceAsString,
        res.title,
        res.executingCompany,
        res.bedenken,
        res.appFileCount,
        res.appUploadedFileCount,
        res.signatureFileId,
        res.constructionDiaryNumber,
        res.name
    );
}
